import { BASE_EXTRA_DATA } from "./baseExtraData";
import { useCallback, useState, useEffect } from "react";
export default function useTracking() {
    const [isReady, setIsReady] = useState(!!window.getLaquesisVariant);
    const [eventQueue, setEventQueue] = useState([]);
    // handle Ninja readiness (Ninja injects Laquesis, so when that's ready, so is Ninja)
    useEffect(() => {
        if (isReady)
            return;
        const interval = setInterval(() => {
            if (window.getLaquesisVariant)
                setIsReady(true);
        }, 100);
        return () => clearInterval(interval);
    }, [isReady]);
    // handle processing of pending events once Ninja is ready
    useEffect(() => {
        if (!isReady || !eventQueue.length)
            return;
        eventQueue.forEach((event) => { var _a; return (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(event); });
        // clear event queue after processing pending events
        setEventQueue([]);
    }, [isReady, eventQueue]);
    const pushEvent = useCallback((event) => {
        var _a;
        // queue event if Ninja is not ready yet
        if (!isReady) {
            setEventQueue((prevQueue) => [...prevQueue, event]);
            return;
        }
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(event);
    }, [isReady]);
    const trackPageView = useCallback((pageName, extraData) => {
        const event = Object.assign(Object.assign({ event_type: "pv", trackPage: pageName }, BASE_EXTRA_DATA), extraData);
        pushEvent(event);
    }, [pushEvent]);
    const trackEvent = useCallback((eventName, extraData) => {
        const event = Object.assign(Object.assign({ event_type: "click", trackEvent: [eventName] }, BASE_EXTRA_DATA), extraData);
        pushEvent(event);
    }, [pushEvent]);
    return { trackPageView, trackEvent };
}
